import React, { useContext, useState } from "react";
import { ClinicaContext } from "../../shared/context/clinica-context";
import { AuthContext } from "../../shared/context/auth-context";
import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import BarChartIcon from "@mui/icons-material/BarChart";
import "./Relatorios.scss";
import PdfMapaFinanceiroWrapper from "../../shared/components/PdfGenerator/PdfMapaFinanceiro/PdfOrcamentoParticular/PdfMapaFinanceiroWrapper";

import RelatoriosFinanceiro from "./components/relatoriosFinanceiro/RelatoriosFinanceiro";
import RelatoriosAgendamentos from "./components/relatoriosAgendamentos/RelatoriosAgendamentos";
import RelatoriosOrcamentos from "./components/relatoriosOrcamentos/RelatoriosOrcamentos";
import RelatoriosPlanosTratamento from "./components/relatoriosPlanosTratamento/RelatoriosPlanosTratamento";
import RelatoriosDocumentosEletronicos from "./components/relatoriosDocumentosEletronicos/RelatoriosDocumentosEletronicos";
import RelatoriosClientes from "./components/relatoriosClientes/RelatoriosClientes";
import RelatoriosAvaliacoes from "./components/relatoriosAvaliacoes/RelatoriosAvaliacoes";
import RelatoriosComunicacoes from "./components/relatoriosComunicacoes/RelatoriosComunicacoes";
import PdfExtratoClienteWrapper from "../../shared/components/PdfGenerator/PdfExtratoCliente/PdfExtratoClienteWrapper";
import PdfComprovativoDescontoWrapper from "../../shared/components/PdfGenerator/PdfComprovativoDesconto/PdfComprovativoDescontoWrapper";

function Relatorios() {
  const clinica = useContext(ClinicaContext);
  const auth = useContext(AuthContext);
  const [showMainTabs, setShowMainTabs] = useState("financeiro");
  const [mapaData, setMapaData] = useState({ show: false });
  const [extratoData, setExtratoData] = useState({ show: false });
  const [comprovativoDescontoData, seComprovativoDescontoData] = useState({
    show: false,
  });

  const dadosMapa = (dados, clinicaData, dataInicial, dataFinal) => {
    setMapaData({
      dados: dados,
      clinicaData: clinicaData,
      dataInicial,
      dataFinal,
      show: true,
    });
  };

  const showExtrato = (dados) => {
    setExtratoData({
      dados: dados,
      show: true,
    });
  };

  const showPreviousPage = () => {
    if (mapaData.show) {
      setMapaData({ show: false });
    }
    if (extratoData.show) {
      setExtratoData({ show: false });
    }
    if (comprovativoDescontoData.show) {
      seComprovativoDescontoData({ show: false });
    }
  };

  const gerarPdfComprovativoDesconto = (data, dados) => {
    seComprovativoDescontoData({
      dados: dados,
      clinica: clinica.clinica,
      data: data,
      show: true,
    });
  };

  return (
    <>
      {mapaData.show && (
        <PdfMapaFinanceiroWrapper
          showSinglePage={showPreviousPage}
          mapaData={mapaData}
        />
      )}

      {extratoData.show && (
        <PdfExtratoClienteWrapper
          showPreviousPage={showPreviousPage}
          dados={extratoData.dados}
        />
      )}

      {comprovativoDescontoData.show && (
        <PdfComprovativoDescontoWrapper
          showPreviousPage={showPreviousPage}
          comprovativoDescontoData={comprovativoDescontoData}
        />
      )}

      {!mapaData.show && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar title="Relatórios" icon={BarChartIcon} />
            <div>
              <div className="single__abas-principais single__abas-principais--relatorio">
                {/* <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "avaliacoes" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("avaliacoes")}
                >
                  Avaliações
                </span> */}

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "financeiro" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("financeiro")}
                >
                  Financeiro
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "orcamentos" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("orcamentos")}
                >
                  Orcamentos
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "clientes" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("clientes")}
                >
                  Clientes
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "agendamentos" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("agendamentos")}
                >
                  Agendamentos
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "documentosEletronicos" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("documentosEletronicos")}
                >
                  Documentos Eletrónicos
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "planostratamento" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("planostratamento")}
                >
                  Tratamentos
                </span>

                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "comunicacoes" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("comunicacoes")}
                >
                  Comunicações
                </span>
              </div>
              <div className="relatoriosContainer">
                {showMainTabs === "avaliacoes" && (
                  <div className="caixa">
                    <RelatoriosAvaliacoes clinica={clinica} auth={auth} />
                  </div>
                )}

                {showMainTabs === "financeiro" && (
                  <div className="caixa">
                    <RelatoriosFinanceiro
                      clinicaId={clinica.clinica._id}
                      auth={auth}
                      dadosMapa={dadosMapa}
                      showExtrato={showExtrato}
                    />
                  </div>
                )}

                {showMainTabs === "agendamentos" && (
                  <div className="caixa">
                    <RelatoriosAgendamentos clinica={clinica} auth={auth} />
                  </div>
                )}

                {showMainTabs === "orcamentos" && (
                  <div className="caixa">
                    <RelatoriosOrcamentos
                      clinica={clinica}
                      auth={auth}
                      gerarPdfComprovativoDesconto={
                        gerarPdfComprovativoDesconto
                      }
                    />
                  </div>
                )}

                {showMainTabs === "planostratamento" && (
                  <div className="caixa">
                    <RelatoriosPlanosTratamento clinica={clinica} auth={auth} />
                  </div>
                )}

                {showMainTabs === "documentosEletronicos" && (
                  <div className="caixa">
                    <RelatoriosDocumentosEletronicos
                      clinica={clinica}
                      auth={auth}
                    />
                  </div>
                )}

                {showMainTabs === "clientes" && (
                  <div className="caixa">
                    <RelatoriosClientes clinica={clinica} auth={auth} />
                  </div>
                )}

                {showMainTabs === "comunicacoes" && (
                  <div className="caixa">
                    <RelatoriosComunicacoes clinica={clinica} auth={auth} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Relatorios;
